module.exports = __webpack_public_path__ + "static/img/inventory.5c9beba7.png";